<template>
  <el-dialog
    :title="`Отправить смс`"
    :visible="visible"
    width="50%"
    custom-class="send-notification-modal"
    :close-on-click-modal="false"
    class="send-sms-modal"
    @close="beforeClose"
  >
    <loader-wrapper :loading="isLoading">
      <p style="font-size: 14px; color: #98a9bc; margin-bottom: 12px">
        {{ `количество пользователей: ${checkedRequest.length}` }}
      </p>
      <el-row>
        <el-input
          v-model="textarea"
          :rows="10"
          :maxlength="70"
          type="textarea"
        />
      </el-row>
      <el-row>
        <p style="font-size: 14px; color: rgb(230, 162, 60); margin-top: 12px">
          {{ `осталось символов: ${70 - textarea.length}` }}
        </p>
      </el-row>
      <el-row>
        <p
          v-show="textarea.length < 20"
          style="font-size: 14px; color: #f56c6c; margin-top: 12px"
        >
          {{ `минимальное количество символов: 20` }}
        </p>
      </el-row>
    </loader-wrapper>
    <div slot="footer" class="dialog-footer">
      <el-button
        :disabled="textarea.length < 20"
        type="primary"
        :loading="loading"
        @click="onSend"
      >
        Отправить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Sms = RepositoryFactory.get('smsRepository')

export default {
  name: 'SendSmsModal',
  components: { LoaderWrapper },

  props: {
    checkedRequest: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      textarea: '',
      loading: false,
      isLoading: false,
    }
  },
  computed: {},

  watch: {
    textarea() {},
  },
  methods: {
    onSend() {
      const { textarea: text, checkedRequest } = this
      let response_ids = []

      checkedRequest.map(item => response_ids.push(item.id))

      this.loading = true

      Sms.pushSmsRequests({ text, response_ids })
        .then(res => {
          if (res.status === 200) {
            this.$message.success('Уведомление водителям отправлено')
            this.beforeClose()
          }
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    beforeClose() {
      this.$emit('close')
      this.textarea = ''
    },
  },
}
</script>

<style lang="sass">
.send-sms-modal
  .el-dialog__header
    padding: 20px 20px 0px
    color: #000
  .el-dialog__body
    padding: 0 20px 20px!important
    color: #000
  .send-group
    margin-bottom: 16px
</style>
